import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaChevronDown } from 'react-icons/fa';
import navigationData from '../data/navigation.json';
import './Navbar.css';

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
    setDropdownOpen(false);
  }, [location]);

  return (
    <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          <span className="brand-cyber">Cyber</span>
          <span className="brand-seqr">seqr</span>
        </Link>

        <button
          className="navbar-toggle"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle navigation"
        >
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>

        <ul className={`navbar-links ${isOpen ? 'navbar-links-open' : ''}`}>
          {navigationData.links.map((link) => (
            <li
              key={link.label}
              className={`navbar-item ${link.children ? 'has-dropdown' : ''}`}
              onMouseEnter={() => link.children && setDropdownOpen(true)}
              onMouseLeave={() => link.children && setDropdownOpen(false)}
            >
              {link.children ? (
                <>
                  <button
                    className={`navbar-link dropdown-trigger ${
                      location.pathname.startsWith('/services') ? 'active' : ''
                    }`}
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                  >
                    {link.label} <FaChevronDown className="dropdown-icon" />
                  </button>
                  <ul className={`dropdown-menu ${dropdownOpen ? 'dropdown-open' : ''}`}>
                    <li>
                      <Link to={link.path} className="dropdown-item">
                        All Services
                      </Link>
                    </li>
                    {link.children.map((child) => (
                      <li key={child.label}>
                        <Link to={child.path} className="dropdown-item">
                          {child.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <Link
                  to={link.path}
                  className={`navbar-link ${
                    location.pathname === link.path ? 'active' : ''
                  }`}
                >
                  {link.label}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
